import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography/Typography'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { fetchUserData } from 'store/userSlice'
import { COLORS } from 'styles/colors'
import { MainSidebarLink } from 'ui/sidebar/shared/MainSidebarLink/MainSidebarLink'
import { TypographyPrimary16B } from 'ui/typography/TypographyPrimary16B'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { getFirstWordsFromName } from 'utils'

const UserMenu = () => {
	const { userData, userDataPending } = useAppSelector(s => s.userReducer)
	const dispatch = useAppDispatch()

	useEffect(() => {
		dispatch(fetchUserData())
	}, [dispatch])

	const displayName =
		userData?.firstname && userData?.lastname
			? `${userData.firstname} ${userData.lastname.charAt(0)}.`
			: 'Профиль'

	const avatarElement = (
		<Box
			sx={{
				mt: '4px', // опускаем, как в макете
				width: '16px',
				height: '16px',
				borderRadius: '50%',
				overflow: 'hidden',
				flex: '0 0 auto',
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
				bgcolor: '#fff',
			}}
		>
			{userDataPending ? (
				<Skeleton variant='circular' width={'16px'} height={'16px'} />
			) : userData?.avatar ? (
				<Box
					component='img'
					src={userData.avatar}
					alt='Avatar'
					sx={{
						display: 'block',
						width: '100%',
						height: '100%',
						objectFit: 'cover',
					}}
				/>
			) : (
				<Typography
					sx={{
						color: COLORS.black,
						fontFamily: 'Montserrat',
						fontSize: '8px',
						fontWeight: 700,
						lineHeight: 1,
					}}
				>
					{getFirstWordsFromName(userData?.firstname, userData?.lastname)}
				</Typography>
			)}
		</Box>
	)

	return (
		<MainSidebarLink
			to='/profile'
			icon={avatarElement}
			textMenu={
				userDataPending ? (
					<Box>
						<Skeleton variant='text' width={'96px'} height={'20px'} />
						<Skeleton
							variant='text'
							width={'120px'}
							height={'18px'}
							sx={{ mt: '4px' }}
						/>
					</Box>
				) : (
					<Box sx={{ color: 'inherit' }}>
						<TypographyPrimary16B
							sx={{
								whiteSpace: 'nowrap',
								textOverflow: 'ellipsis',
								overflow: 'hidden',
								color: 'inherit',
							}}
						>
							{displayName}
						</TypographyPrimary16B>
						<TypographySecondary>
							{userData?.position || 'Должность'}
						</TypographySecondary>
					</Box>
				)
			}
		/>
	)
}

export default UserMenu
